module.exports = __webpack_public_path__ + "static/media/workshop_0004.9e811704.png";